import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from './ui/card';
import { Star } from 'lucide-react';
import { useScrollAnimation, useStaggeredAnimation } from '../hooks/useScrollAnimation';

const Testimonials = () => {
  const { t } = useTranslation();
  const [titleRef, titleVisible] = useScrollAnimation(0.1);
  const [gridRef, visibleTestimonials] = useStaggeredAnimation(3, 200);

  const testimonials = t('testimonialsData', { returnObjects: true });

  return (
    <section id="testimonials" className="py-24 bg-neutral-950">
      <div className="max-w-7xl mx-auto px-6">
        <div 
          ref={titleRef}
          className={`text-center mb-16 fade-in ${titleVisible ? 'visible' : ''}`}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t('testimonials.title')}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            {t('testimonials.subtitle')}
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => {
            const isVisible = visibleTestimonials.has(index);
            return (
              <Card
                key={index}
                className={`bg-black border-neutral-800 hover:border-white/20 transition-all duration-300 slide-up ${isVisible ? 'visible' : ''}`}
              >
                <CardContent className="pt-6">
                  {/* Star Rating */}
                  <div className="flex gap-1 mb-4">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-white text-white" />
                    ))}
                  </div>

                  {/* Content */}
                  <p className="text-gray-300 mb-6 leading-relaxed">
                    "{testimonial.content}"
                  </p>

                  {/* Author */}
                  <div className="border-t border-neutral-800 pt-4">
                    <p className="text-white font-semibold">
                      {testimonial.name}
                    </p>
                    <p className="text-gray-500 text-sm">
                      {testimonial.role}
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
